"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useMedia_1 = require("react-use/lib/useMedia");
const json2mq = require("json2mq");
exports.createUseMedia = (query, targetWindow) => {
    if (typeof query !== 'string')
        query = json2mq(query);
    const useMedia = () => useMedia_1.default(query, targetWindow);
    return useMedia;
};
exports.useMedia = (query, targetWindow) => {
    return useMedia_1.default(typeof query !== 'string' ? json2mq(query) : query, targetWindow);
};
